/**
 * Extrait les blocs GenUI reconnus depuis le texte (fallback client, streaming).
 * Ne valide que des blocs complets (JSON parseable).
 */

const ALLOWED = new Set(['comparison_chart']);

function pushBlock(blocks, type, data) {
  if (!ALLOWED.has(type) || data == null) return;
  blocks.push({
    id: `genui-${blocks.length}-${Date.now()}`,
    type,
    data,
  });
}

/**
 * @param {string} text
 * @returns {{ cleanedText: string, blocks: Array<{ id: string, type: string, data: unknown }> }}
 */
export function tryExtractGenUIFromText(text) {
  const blocks = [];
  if (!text || typeof text !== 'string') {
    return { cleanedText: '', blocks };
  }

  let cleaned = text;

  const genuiRe = /<genui\s*>([\s\S]*?)<\/genui>/gi;
  cleaned = cleaned.replace(genuiRe, (_, inner) => {
    try {
      const obj = JSON.parse(String(inner).trim());
      if (obj && typeof obj === 'object' && obj.type) {
        pushBlock(blocks, obj.type, obj.data);
      }
    } catch {
      /* ignore */
    }
    return '';
  });

  const fenceRe = /```(?:json)?\s*([\s\S]*?)```/gi;
  cleaned = cleaned.replace(fenceRe, (full, inner) => {
    try {
      const obj = JSON.parse(String(inner).trim());
      if (obj && typeof obj === 'object' && obj.type && ALLOWED.has(obj.type)) {
        pushBlock(blocks, obj.type, obj.data);
        return '';
      }
    } catch {
      /* keep fence if not valid genui */
    }
    return full;
  });

  return { cleanedText: cleaned, blocks };
}

/**
 * Masque un <genui> non fermé en fin de flux pour l'aperçu streaming.
 * @param {string} text
 */
export function hideIncompleteGenui(text) {
  if (!text) return '';
  const lower = text.toLowerCase();
  const start = lower.lastIndexOf('<genui');
  if (start === -1) return text;
  const rest = text.slice(start);
  if (/<\/genui>/i.test(rest)) return text;
  return text.slice(0, start);
}
